import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";

import dashboard from "../Images/dashboard.png";
import idreport from "../Images/idreport.png";
import studentboard from "../Images/studentboard.png";
import report from "../Images/report.png";

export default function ReportsAndAccess() {
  const reports = [
    {
      title: "Dashboard Access to College",
      //   description:
      //     "SWOT Analysis and performance tracking for institutional oversight",
      image: dashboard,
    },
    {
      title: "Consolidated Report to College",
      //   description: "Comprehensive metrics and performance indicators overview",
      image: report,
    },
    {
      title: "Dashboard Access to Students",
      //   description: "Student portal with personalized information and resources",
      image: studentboard,
    },
    {
      title: "Individual Report to Students",
      //   description: "Detailed personal performance reports and analytics",
      image: idreport,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        margin: "0 auto",
        padding: "24px",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#1f2937" }}
      >
        Reports & Access
      </Typography>

      <Grid container spacing={1}>
        {reports.map((report, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                transition: "box-shadow 0.3s",
                "&:hover": {
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                },
              }}
            >
              <CardMedia
                component="img"
                height="220"
                width="380"
                image={report.image}
                alt={report.title}
              />
              <CardContent>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: "600",
                    marginBottom: "8px",
                    color: "#111827",
                  }}
                >
                  {report.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
